import React, { useState } from 'react';
import {
  Drawer,
  DrawerProps,
  Button,
  Stack,
  CheckPicker,
  Checkbox,
  Panel,
  DatePicker, Form, Input, TagPicker
} from 'rsuite';


const data = ['Product Type', 'Carton Type', 'Size Unit', 'Length', 'Width', 'Height', 'Color', 'Finish'].map(
  item => ({ label: item, value: item })
);


const DrawerLink = (props: DrawerProps,) => {
  const { onClose, ...rest } = props;




  // Checkboc Hide Show 1
  const [checked, setChecked] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleCheckboxClick = () => {
    setChecked(!checked);
  }

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  // Checkboc Hide Show 2
  const [checked1, setChecked1] = useState(false);
  const [inputValue1, setInputValue1] = useState('');

  const handleCheckboxClick1 = () => {
    setChecked1(!checked1);
  };

  const handleInputChange1 = (value) => {
    setInputValue1(value);
  };

  // Checkboc Hide Show 3
  const [checked2, setChecked2] = useState(false);
  const [inputValue2, setInputValue2] = useState('');

  const handleCheckboxClick2 = () => {
    setChecked2(!checked2);
  };

  const handleInputChange2 = (value) => {
    setInputValue2(value);
  };



  return (
    <Drawer backdrop="static" size="xs" placement="right" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Title>Link settings</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="default">
            Cancel
          </Button>
          <Button color="cyan" onClick={onClose} appearance="primary">
            Done
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <Panel>
          <Stack direction='column' alignItems='flex-start' spacing={5}>
            <h6>Update link settings</h6>
            <label>Change setting for password security and expiry date</label>
            <Checkbox>
              <Stack direction='column' alignItems='flex-start' spacing={4}>
                <b>Email required to view catalogue</b>
                <label>Catalogue will only be visible once email id is entered</label>
              </Stack>
            </Checkbox>
            <Checkbox checked={checked} onChange={handleCheckboxClick} >
              <Stack direction='column' alignItems='flex-start' spacing={4}>
                <b>Link expires on</b>
                <label>Link will be automatically deactivated after the selected date</label>
                {checked && (
                  <Input type="date" style={{ width: 320 }} value={inputValue} onChange={handleInputChange} />
                )}
              </Stack>
            </Checkbox>
            <Checkbox checked={checked1} onChange={handleCheckboxClick1}>
              <Stack direction='column' alignItems='flex-start' spacing={4}>
                <b> Passcode protect</b>
                <label>Add a 6-digit passcode to protect your catalogue</label>
                {checked1 && (
                  <Input type="password" style={{ width: 320 }} value={inputValue1} onChange={handleInputChange1} />
                )}

              </Stack>
            </Checkbox>
            <Checkbox>
              <Stack direction='column' alignItems='flex-start' spacing={4}>
                <b> Allow PPT download</b>
                <label>PPT for catalogue can be downloaded from the link</label>
              </Stack></Checkbox>
            <Checkbox checked={checked2} onChange={handleCheckboxClick2}>
              <Stack direction='column' alignItems='flex-start' spacing={4}>
                <b>Show Products Filters</b>
                <label>Product filters will be visible in your catalogue</label>
                {checked2 && (
                  <TagPicker
                    data={data}
                    defaultValue={['Product Type', 'Carton Type', 'Size Unit', 'Length', 'Width', 'Height', 'Color', 'Finish']}
                    // disabledItemValues={['Bryan', 'Linda', 'Nancy']}
                    style={{ width: 300 }}
                    menuStyle={{ width: 300 }}
                  />
                )}
              </Stack> </Checkbox>

          </Stack>

        </Panel>
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerLink;